import { connect } from 'react-redux'
import Conclusion from './conclusion'
import { getConflicts } from '../../../../../../stores/conflict-resolution/conflict-resolution.selectors'

const mapStateToProps = state => {
  const conflicts = getConflicts(state)
  return {
    importedStudentsCount: conflicts && conflicts.imported_students_count
  }
}

export default connect(
  mapStateToProps,
  null
)(Conclusion)
